export default function filterFieldsInObject(obj: Record<string, any>, filterValue: any) {
  return Object.entries(obj).reduce((acc, [key, value]) => ({
    ...acc,
    ...(value !== filterValue
      ? { [key]: value }
      : {}
    ),
  }), {} as Record<string, any>);
}